import React from "react";
import styled from "styled-components";
import { selectLayers } from "../../features/counter/counterSlice";
import { SHAPE_TYPES } from "../../utils";
import TextComponent from "../layers/TextComponent";
import ImageComponent from "../layers/ImageComponent";

import { useSelector, useDispatch } from "react-redux";

const Stage = styled.div`
  width: 29.7cm;
  height: 21cm;
  background: #ccc;
  transform: scale(${(props) => (props.scale ? props.scale : 1)});
  transform-origin: center center;
  position: absolute;
  overflow: hidden;
`;

function EditorComponent({ dimensions }) {
  const [scale, setScale] = React.useState(null);
  const [canvasSize, setCanvasSize] = React.useState(null);
  const layers = useSelector(selectLayers);
  React.useEffect(() => {
    if (canvasSize && dimensions) {
      const value = Math.min(
        (dimensions.width - 20) / canvasSize.width,
        (dimensions.height - 20) / canvasSize.height
      );
      console.log({ dimensions, canvasSize, value });
      setScale(value);
    }
  }, [dimensions, canvasSize]);

  const useStageLayoutRef = React.useCallback((ref) => {
    if (ref !== null) {
      setCanvasSize({
        width: ref.offsetWidth,
        height: ref.offsetHeight,
      });
    }
  }, []);

  return (
    <Stage ref={useStageLayoutRef} scale={scale}>
      {layers.map((layer) => {
        switch (layer.type) {
          case SHAPE_TYPES.TEXT_ELEMENT:
            return <TextComponent layer={layer} key={layer.id} />;

          case SHAPE_TYPES.IMAGE_ELEMENT:
            return <ImageComponent layer={layer} key={layer.id} />;

          default:
            return null;
        }
      })}
    </Stage>
  );
}

export default EditorComponent;
